var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCrossCircleYellow16Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "05F6BC98-E4E0-4289-B3FD-2B2448FC5669_SVG") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\xC4riklient",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Kaardid---Expanded",
    transform: "translate(-1055.000000, -1356.000000)",
    fill: "#FFCD00"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-39",
    transform: "translate(208.000000, 280.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-24",
    transform: "translate(0.000000, 816.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Kaart-/-Master-Copy-4",
    transform: "translate(0.000000, 56.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-4",
    transform: "translate(24.000000, 190.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-31"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-38"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(750.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(73.000000, 14.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.6570007,2.343 C10.5320007,-0.781 5.4679997,-0.781 2.3429997,2.343 C-0.7809999,5.467 -0.7809999,10.532 2.3429997,13.657 C5.4679997,16.7810001 10.5320007,16.7810001 13.6570007,13.657 C16.7810007,10.532 16.7810007,5.467 13.6570007,2.343 Z M12.2420007,12.242 C9.8990007,14.585999 6.0999997,14.585999 3.7579997,12.242 C1.4139997,9.899 1.4139997,6.099999 3.7579997,3.757 C6.1009997,1.414 9.9000007,1.414 12.2420007,3.757 C14.5860007,6.101 14.5860007,9.899 12.2420007,12.242 Z M10.8280007,5.172 C10.4370007,4.781 9.8050007,4.781 9.4140007,5.172 L8.0000007,6.586 L6.5860007,5.172 C6.1950007,4.781 5.5630007,4.781 5.1720007,5.172 C4.7810007,5.563 4.7810007,6.195 5.1720007,6.586 L6.5860007,8 L5.1720007,9.414 C4.7810007,9.804999 4.7810007,10.436999 5.1720007,10.827999 C5.5630007,11.218999 6.1950007,11.218999 6.5860007,10.827999 L8.0000007,9.414 L9.4140007,10.827999 C9.8049997,11.218999 10.4370007,11.218999 10.8280007,10.827999 C11.2190007,10.436999 11.2190007,9.804999 10.8280007,9.414 L9.4140007,8 L10.8280007,6.586 C11.2190007,6.195 11.2190007,5.563 10.8280007,5.172 Z",
    id: "Icon_Cross-Circle_Yellow-16px"
  }))))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCrossCircleYellow16Px);
export default __webpack_public_path__ + "static/media/Icon_Cross-Circle_Yellow-16px.48ae1aa37417523d4e6447569bf03aeb.svg";
export { ForwardRef as ReactComponent };